import React from 'react'
import MessageHistoryList from './MessageHistoryList'
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Backdrop,
  makeStyles
} from '@material-ui/core'
import { Height } from '@material-ui/icons'

const useStyles = makeStyles(theme => ({
  dialog: {},
  flexCenter: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }
}))

const MessageHistoryModal: React.FC<{
  kaiinNo: string
  isOpen: boolean
  closeHandler: () => void
}> = ({ kaiinNo, isOpen, closeHandler }) => {
  const classes = useStyles()
  const handleClose = () => {
    closeHandler()
  }

  return (
    <Dialog
      fullWidth
      maxWidth="lg"
      open={isOpen}
      onClose={handleClose}
      BackdropComponent={Backdrop}
      closeAfterTransition
      className={classes.dialog}
    >
      <DialogContent>
        <MessageHistoryList kaiinNo={kaiinNo} isModal />
      </DialogContent>
      <DialogActions className={classes.flexCenter}>
        <Button variant="contained" onClick={handleClose} color="primary">
          閉じる
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default MessageHistoryModal
